import { isEmpty } from 'lodash';
import getDeterminantNetworkId from './getDeterminantNetworkId';

const networkIdExists = (fields) => (
  !isEmpty(getDeterminantNetworkId(fields))
);

export default networkIdExists;
